import React, { useEffect } from 'react';
import { Field, useFormikContext } from 'formik';
import { SttDatePicker } from '@stt-componentes/core';
import { SITUACAO } from '../constantes';
import { SITUACAO_EXAME, DATA_LAUDO_DE, DATA_INVALIDACAO_DE } from '../fieldNames';

const DataInicialLaudo = ({ strings }) => {
    const { values, setFieldValue } = useFormikContext();
    const exameValido = values[SITUACAO_EXAME].includes(SITUACAO.VALIDO);
    const exameInvalido = values[SITUACAO_EXAME].includes(SITUACAO.INVALIDO);
    const label = (exameValido && exameInvalido) ? strings.dataInicialParecer : exameInvalido ? strings.dataInicialInvalidacao : strings.dataInicialLaudo;

    const fieldName = (exameValido && exameInvalido) ? DATA_LAUDO_DE : exameInvalido ? DATA_INVALIDACAO_DE : DATA_LAUDO_DE;

    useEffect(() => {
        if (exameValido && exameInvalido) {
            return;
        }

        if (exameInvalido) {
            setFieldValue(DATA_LAUDO_DE, null);
        }

        if (exameValido) {
            setFieldValue(DATA_INVALIDACAO_DE, null);
        }
    }, [exameValido, exameInvalido]);

    return (
        <Field name={fieldName}>
                {({ field: { name, value }, form: { setFieldValue, setFieldError, setFieldTouched }, meta }) => {

                let erroAtual = meta.error;
                return (
                    <SttDatePicker
                        label={label}
                        inputProps={{
                            name: name,
                            inputMode: 'numeric'
                        }}
                        disableFuture
                        maxDate={new Date()}
                        error={meta.touched && meta.error ? true : false}
                        onError={error => {
                            if (error && error !== erroAtual) {
                                setFieldError(name, error);
                            }
                        }}
                        value={value}
                        onBlur={() => {
                            setFieldTouched(name, true);
                        }}
                        helperText={meta.touched && meta.error ? meta.error : undefined}
                        onChange={(date) => {
                            if (exameValido && exameInvalido) {
                                setFieldValue(DATA_LAUDO_DE, date);
                                setFieldValue(DATA_INVALIDACAO_DE, date);
                            } 
                            else if (exameInvalido) {
                                setFieldValue(DATA_INVALIDACAO_DE, date);
                            } 
                            else {
                                setFieldValue(DATA_LAUDO_DE, date);
                            }
                        }}
                        onClose={() => setFieldTouched(name, true)}
                    />
                );
            }}
        </Field>
    );
};

export default DataInicialLaudo;